import React from 'react';
import classNames from 'classnames';
import { useDisableScroll } from '~/utils/hooks';

interface LoaderProps {
  className?: string;
  disableScroll?: boolean;
}

const Loader: React.FC<LoaderProps> = ({
  className = 'overlay',
  disableScroll = false,
}) => {
  useDisableScroll(disableScroll);

  return (
    <div className={classNames('loader-overlay', { [className]: className })}>
      <div className="loader-spinner"></div>
    </div>
  );
};

export default Loader;
